import * as React from "react";
import { CheckCircleIcon } from "../../../ui";
import { INVOICED_BLUE, InvoicedMark, MARK_LABELS } from "../inspectionSummary.utils";

/** Invoiced: a blue check circle. Quoted but not invoiced: a dotted empty circle. Neither: nothing to say. */
export const InvoicedCell: React.FC<{ mark?: InvoicedMark | null }> = ({ mark }) =>
  mark === InvoicedMark.INVOICED ? (
    <span role="img" aria-label={MARK_LABELS[mark]} title={MARK_LABELS[mark]} className="flex justify-center">
      <CheckCircleIcon style={{ fontSize: "1.25rem", color: INVOICED_BLUE }} />
    </span>
  ) : mark === InvoicedMark.QUOTED ? (
    <span role="img" aria-label={MARK_LABELS[mark]} title={MARK_LABELS[mark]} className="flex justify-center">
      <span className="block rounded-full" style={{ width: 17, height: 17, border: "2px dotted #94a3b8" }} />
    </span>
  ) : (
    <span />
  );
